import {
  AmenityCode,
  TravelReservation_Arrival,
  TravelReservation_Origin
} from '@com-delta-idp/mnx-trip-management-shared-ui';

export const TRANSPORT_ATL_ARRIVAL: TravelReservation_Arrival = {
  scheduledArrivalLocalDateTime: '2023-02-19T08:20:00-05:00',
  estimatedArrivalLocalDateTime: '2023-02-19T08:20:00-05:00',
  station: {
    code: 'ATL',
    name: 'Hartsfield-Jackson Atlanta Intl',
    postalAddress: {
      cityName: 'Atlanta',
      countrySubdivision: {
        code: 'GA'
      },
      country: {
        code: 'US'
      }
    }
  }
};

export const TRANSPORT_ATL_ORIGIN: TravelReservation_Origin = {
  scheduledDepartureLocalDateTime: '2023-02-19T07:00:00-05:00',
  estimatedDepartureLocalDateTime: '2023-02-19T07:00:00-05:00',
  station: {
    code: 'ATL',
    name: 'Hartsfield-Jackson Atlanta Intl',
    postalAddress: {
      cityName: 'Atlanta',
      countrySubdivision: {
        code: 'GA'
      },
      country: {
        code: 'US'
      }
    }
  }
};

export const TRANSPORT_HNL_ARRIVAL: TravelReservation_Arrival = {
  scheduledArrivalLocalDateTime: '2023-02-24T18:25:00-10:00',
  estimatedArrivalLocalDateTime: '2023-02-24T18:25:00-10:00',
  station: {
    code: 'HNL',
    name: 'Honolulu Intl',
    postalAddress: {
      cityName: 'Honolulu',
      countrySubdivision: {
        code: 'HI'
      },
      country: {
        code: 'US'
      }
    }
  }
};

export const TRANSPORT_HNL_ORIGIN: TravelReservation_Origin = {
  scheduledDepartureLocalDateTime: '2023-02-19T07:00:00-05:00',
  estimatedDepartureLocalDateTime: '2023-02-19T07:00:00-05:00',
  station: {
    code: 'HNL',
    name: 'Honolulu Intl',
    postalAddress: {
      cityName: 'Honolulu',
      countrySubdivision: {
        code: 'HI'
      },
      country: {
        code: 'US'
      }
    }
  }
};

export const TRANSPORT_JAX_ARRIVAL: TravelReservation_Arrival = {
  scheduledArrivalLocalDateTime: '2023-02-19T08:20:00-05:00',
  estimatedArrivalLocalDateTime: '2023-02-19T08:20:00-05:00',
  station: {
    code: 'JAX',
    name: 'Jacksonville Intl',
    postalAddress: {
      cityName: 'Jacksonville',
      countrySubdivision: {
        code: 'FL'
      },
      country: {
        code: 'US'
      }
    }
  }
};

export const TRANSPORT_JAX_ORIGIN: TravelReservation_Origin = {
  scheduledDepartureLocalDateTime: '2023-02-19T07:00:00-05:00',
  scheduledDepartureUtcDateTime: '2023-02-19T07:00:00-05:00',
  estimatedDepartureLocalDateTime: '2023-02-19T07:00:00-05:00',
  station: {
    code: 'JAX',
    name: 'Jacksonville Intl',
    postalAddress: {
      cityName: 'Jacksonville',
      countrySubdivision: {
        code: 'FL'
      },
      country: {
        code: 'US'
      }
    }
  }
};

export const AMENITIES: AmenityCode[] = [
  {
    code: 'AMG03N'
  },
  {
    code: 'AMG038'
  },
  {
    code: 'AMG039'
  },
  {
    code: 'AMG040'
  },
  {
    code: 'AMG071'
  },
  {
    code: 'AM0AEY'
  },
  {
    code: 'AMG17V'
  },
  {
    code: 'AMG186'
  },
  {
    code: 'AMG253'
  },
  {
    code: 'AMG181'
  }
];
